module.exports = __webpack_public_path__ + "img/4.f6fa6f0d.png";